module.exports = __webpack_public_path__ + "img/Pink Standard.5884a1b6.jpg";